<template>
	<div class="resetPassword">
		<el-form :model="ruleForm" status-icon :rules="rules" ref="resetPass" label-width="100px">
			<el-form-item label="原密码" prop="password">
				<div class="el-form-item-content">
					<el-input type="password" v-model="ruleForm.password" placeholder="请输入原密码"  autocomplete="off">
						<img slot="prefix" src="../../assets/image/lock.png" alt="" />
					</el-input>
				</div>
			</el-form-item>
			<el-form-item label="新密码" prop="new_password">
				<div class="el-form-item-content">
					<el-input type="password" v-model="ruleForm.new_password" placeholder="请输入6-12位的字母或者数字组合"  autocomplete="off">
						<img slot="prefix" src="../../assets/image/lock.png" alt="" />
					</el-input>
				</div>
			</el-form-item>
			<el-form-item label="新密码" prop="new_passwordTwo">
				<div class="el-form-item-content">
					<el-input type="password" v-model="ruleForm.new_passwordTwo" placeholder="请再次输入密码"  autocomplete="off">
						<img slot="prefix" src="../../assets/image/lock.png" alt="" />
					</el-input>
				</div>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submitForm('resetPass')">确认修改</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	import {
		mapActions
	} from 'vuex'
	export default {
		name: 'ResetPassword',
		data() {
			let validateNew_password = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入新密码'))
				} else {
					let rule = /^[a-z|A-Z|0-9]{6,12}$/
					if (!rule.test(value)) {
						callback(new Error('您输入的密码不符合规则，请重新输入'))
					}
					callback()
				}
			}
			let validateNew_passwordTwo = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'))
				} else {
					if (value !== this.ruleForm.new_password) {
						callback(new Error('两次输入的密码不一样，请重新输入'))
					}
					callback()
				}
			}
			return {
				ruleForm: {
					password: '',
					new_password: '',
					new_passwordTwo: ''
				},
				rules: {
					password: [{
						required: true,
						message: '请输入原密码',
						trigger: 'blur'
					}],
					new_password: [{
						validator: validateNew_password,
						required: true,
						trigger: 'blur'
					}],
					new_passwordTwo: [{
						validator: validateNew_passwordTwo,
						required: true,
						trigger: 'blur'
					}]
				},
			}
		},
		methods: {
			...mapActions('login', ['Editpass']),
			submitForm(formName) {
				this.$refs[formName].validate(async (valid) => {
					console.log(valid, 'ppp')
					if(valid) {
						console.log('44333')
						let { password, new_password } = this.ruleForm
						await this.Editpass({password, new_password})
						this.$message({
							type:'success',
							message: '修改密码成功'
						})
						this.$router.go(-1)
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.resetPassword {
		width: 600px;
		margin: 0 auto;
		.el-form-item {
			margin-bottom: 22px;
		}
	}
</style>
